import React, { useEffect } from "react";
import { ChevronRight } from "lucide-react";

/**
 * Barra fixa da sacola no rodapé (somente celular, < md), layout docs/tela.
 * Aparece quando há itens no carrinho. Enquanto visível, marca o body com
 * `has-cart-bar` para os botões flutuantes subirem (ver App.css).
 *
 * @param {number} totalItems - Quantidade de itens no carrinho
 * @param {number} totalPrice - Valor total
 * @param {function} formatBRL - Formatador de moeda
 * @param {function} onOpen - Abre o carrinho
 */
export const MobileCartBar = ({
  totalItems = 0,
  totalPrice = 0,
  formatBRL = (value) => value,
  onOpen = () => {},
}) => {
  const visible = totalItems > 0;

  useEffect(() => {
    if (!visible) return;
    document.body.classList.add("has-cart-bar");
    return () => document.body.classList.remove("has-cart-bar");
  }, [visible]);

  if (!visible) return null;

  return (
    <>
      {/* Espaço para a barra fixa não cobrir o fim da página */}
      <div className="h-24 md:hidden" aria-hidden="true" />

      <aside
        aria-label="Resumo da sacola"
        className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-cream-300 shadow-bar px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
      >
        <div className="flex items-center justify-between gap-3 max-w-lg mx-auto">
          <div className="flex flex-col min-w-0">
            <span className="text-[11px] text-cocoa-muted font-medium">
              Sacola do pedido
            </span>
            <div className="flex items-baseline gap-1.5">
              <span className="text-base font-extrabold text-brand-600 leading-tight">
                {formatBRL(totalPrice)}
              </span>
              <span className="text-[11px] font-bold text-cocoa-muted whitespace-nowrap">
                • {totalItems} {totalItems === 1 ? "item" : "itens"}
              </span>
            </div>
          </div>
          <button
            type="button"
            onClick={onOpen}
            className="flex-grow max-w-[13rem] min-h-[48px] inline-flex items-center justify-center gap-1.5 bg-brand-600 hover:bg-brand-700 active:scale-95 text-white font-extrabold text-xs uppercase tracking-wider px-5 rounded-xl shadow-float transition"
          >
            Ver sacola
            <ChevronRight className="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
      </aside>
    </>
  );
};
